import { moment } from "@msuite/utils/date";
import { StatusIndicator } from "../status-indicator";
import { cn } from "../utils";
import type { CalendarDayBaseProps } from "./shared";

/** Props Interface */
interface CalendarDayHeaderProps<T extends object = object> extends CalendarDayBaseProps<T> {}

export function CalendarDayHeader<T extends object>({ item }: CalendarDayHeaderProps<T>) {
	const _moment = moment(item.date);

	/** Render */
	return (
		<div
			className={cn(
				"w-full bg-primary-100 dark:bg-primary-900 flex py-4 flex-row flex-center sticky top-0 border-b-[0.5px] border-color gap-2",
				"z-1",
			)}
		>
			{_moment.isToday() && (
				<StatusIndicator
					color="red"
					className="shrink-0"
				/>
			)}
			<p className="text-xs">{_moment.dateFormat()}</p>
		</div>
	);
}
